import { render, staticRenderFns } from "./FormulateInputs.vue?vue&type=template&id=31bd14c4&scoped=true"
import script from "./FormulateInputs.vue?vue&type=script&lang=js"
export * from "./FormulateInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bd14c4",
  null
  
)

export default component.exports